module.exports = __webpack_public_path__ + "img/patriot-medical.d0ed24d6.png";